var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdfGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.33301L6 1.33301C5.26667 1.33301 4.66667 1.93301 4.66667 2.66634V10.6663C4.66667 11.3997 5.26667 11.9997 6 11.9997H14C14.7333 11.9997 15.3333 11.3997 15.3333 10.6663V2.66634C15.3333 1.93301 14.7333 1.33301 14 1.33301ZM8.33333 6.33301C8.33333 6.88634 7.88667 7.33301 7.33333 7.33301H6.66667L6.66667 8.66634H5.66667V4.66634H7.33333C7.88667 4.66634 8.33333 5.11301 8.33333 5.66634V6.33301ZM11.6667 7.66634C11.6667 8.21967 11.22 8.66634 10.6667 8.66634H9V4.66634H10.6667C11.22 4.66634 11.6667 5.11301 11.6667 5.66634V7.66634ZM14.3333 5.66634H13.3333V6.33301H14.3333V7.33301H13.3333V8.66634H12.3333V4.66634L14.3333 4.66634V5.66634ZM6.66667 6.33301H7.33333V5.66634H6.66667V6.33301ZM3.33333 3.99967H2L2 13.333C2 14.0663 2.6 14.6663 3.33333 14.6663H12.6667V13.333H3.33333L3.33333 3.99967ZM10 7.66634H10.6667V5.66634H10V7.66634Z",
    fill: "#01B38B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfGreen);
export default __webpack_public_path__ + "static/media/IconPDFGreen.61a2aaa52de00b8e53a14c1c023288ba.svg";
export { ForwardRef as ReactComponent };